export enum PlatformModules {
  MiAccounting = "MiAccounting",
  MiScheduling = "MiScheduling",
  MiDispatch = "MiDispatch",
  MiEstimating = "MiEstimating",
  MiInspections = "MiInspections",
  MiDay = "MiDay",
  MiBuildMobile = "MiBuildMobile",
}
